import React from 'react';

const BangCauXD = ({ dataHistory }) => {
    const recentData = dataHistory ? dataHistory.slice(0, 100) : [];
    
    const parsedData = [...recentData].reverse().map((item, idx, arr) => {
        if (!item.result || item.result.trim() === "") return { valid: false };
        
        const numRed = item.result.trim().split(" ").filter(val => val === "1").length;
        const isChan = numRed % 2 === 0;

        return {
            valid: true,
            numRed,
            isChan,
            isNewest: idx === arr.length - 1
        };
    }).filter(d => d.valid);

    let tongC = 0, tongL = 0, count1 = 0, count2 = 0, count3 = 0, count4 = 0;
    parsedData.forEach(item => {
        if (item.isChan) tongC++; else tongL++;
        if (item.numRed === 4) count1++; 
        if (item.numRed === 0) count2++; 
        if (item.numRed === 3) count3++; 
        if (item.numRed === 1) count4++; 
    });
    const bongRows = 5;
    const bongCols = 8;
    const maxBongItems = bongRows * bongCols;

    const bongFiltered = parsedData.filter(d => d.numRed !== 2);
    const bongDataRaw = bongFiltered.slice(-maxBongItems);
    
    const bongGridFlat = [...bongDataRaw];
    while (bongGridFlat.length < maxBongItems) {
        bongGridFlat.push(null);
    }

    const betRows = 5;
    const betCols = 12;
    
    let betColsArray = [];
    let currentCol = [];
    let lastType = null;

    parsedData.forEach(d => {
        const currentType = d.isChan ? 'C' : 'L';
        if (lastType === null) {
            lastType = currentType;
            currentCol.push(d);
        } else if (lastType === currentType) {
            if (currentCol.length < betRows) {
                currentCol.push(d);
            } else {
                betColsArray.push(currentCol);
                currentCol = [d];
            }
        } else {
            betColsArray.push(currentCol);
            currentCol = [d];
            lastType = currentType;
        }
    });
    if (currentCol.length > 0) betColsArray.push(currentCol);

    let displayBetCols = betColsArray.slice(-betCols);
    while (displayBetCols.length < betCols) {
        displayBetCols.unshift([]);
    }

    const betGridFlat = [];
    displayBetCols.forEach(colData => {
        for (let i = 0; i < betRows; i++) {
            betGridFlat.push(colData[i] || null);
        }
    });

    return (
        <div style={{ background: "#f8f9fa", padding: "6px", borderRadius: "0px", width: "100%", boxSizing: "border-box" }}>
            
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px", fontSize: "10px", fontWeight: "bold", background: "#fff", padding: "5px 4px", borderRadius: "6px", border: "1px solid #eee" }}>
                <span style={{ color: "#007bff" }}>Chẵn: {tongC}</span>
                <span style={{ color: "#dc3545" }}>Lẻ: {tongL}</span>
                <span style={{ color: "#ccc" }}>|</span>
                <span style={{ color: "#ffc107", textShadow: "0px 0px 1px rgba(0,0,0,0.5)" }}>①: {count1}</span>
                <span style={{ color: "#007bff" }}>②: {count2}</span>
                <span style={{ color: "#28a745" }}>③: {count3}</span>
                <span style={{ color: "#dc3545" }}>④: {count4}</span>
            </div>

            <div style={{ display: "flex", gap: "4px", width: "100%", overflow: "hidden" }}>
                
                <div style={{ 
                    width: "40%",
                    background: "#fff", 
                    padding: "2px", 
                    borderRadius: "4px", 
                    border: "1px solid #ddd",
                    display: "grid",
                    gridTemplateRows: `repeat(${bongRows}, 1fr)`,
                    gridTemplateColumns: `repeat(${bongCols}, minmax(0, 1fr))`,
                    gridAutoFlow: "column",
                    gap: "1px"
                }}>
                    {bongGridFlat.map((cell, idx) => {
                        let text = "";
                        let bgColor = "#f4f4f4";
                        let textColor = "white";

                        if (cell) {
                            if (cell.numRed === 4) { text = "1"; bgColor = "#ffc107"; textColor = "#000"; }
                            else if (cell.numRed === 0) { text = "2"; bgColor = "#007bff"; }
                            else if (cell.numRed === 3) { text = "3"; bgColor = "#28a745"; }
                            else if (cell.numRed === 1) { text = "4"; bgColor = "#dc3545"; }
                        }

                        return (
                            <div key={`bong-${idx}`} style={{ 
                                width: "100%",
                                aspectRatio: "1/1", 
                                background: "#f4f4f4", 
                                borderRadius: "2px", 
                                display: "flex", 
                                justifyContent: "center", 
                                alignItems: "center",
                                position: "relative"
                            }}>
                                {cell && (
                                    <div style={{ 
                                        width: "85%", 
                                        height: "85%", 
                                        borderRadius: "50%", 
                                        backgroundColor: bgColor, 
                                        color: textColor, 
                                        display: "flex", 
                                        justifyContent: "center", 
                                        alignItems: "center", 
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        lineHeight: 1,
                                        paddingTop: "1px",
                                        boxShadow: cell.isNewest ? "0 0 4px 2px #ffc107" : "none",
                                        animation: cell.isNewest ? "pulseBong 1s infinite" : "none"
                                    }}>
                                        {text}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                <div style={{ 
                    width: "calc(60% - 4px)", 
                    background: "#fff", 
                    padding: "2px", 
                    borderRadius: "4px", 
                    border: "1px solid #ddd",
                    display: "grid",
                    gridTemplateRows: `repeat(${betRows}, 1fr)`,
                    gridTemplateColumns: `repeat(${betCols}, minmax(0, 1fr))`,
                    gridAutoFlow: "column",
                    gap: "0px"
                }}>
                    {betGridFlat.map((cell, idx) => (
                        <div key={`bet-${idx}`} style={{ 
                            width: "100%",
                            aspectRatio: "1/1",
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center",
                            borderRight: "1px solid #f0f0f0",
                            borderBottom: "1px solid #f0f0f0",
                            position: "relative"
                        }}>
                            {cell && (
                                <div style={{ 
                                    color: cell.isChan ? "#007bff" : "#dc3545", 
                                    fontSize: "12px", 
                                    fontWeight: "900",
                                    lineHeight: 1,
                                    paddingTop: "2px",
                                    animation: cell.isNewest ? "pulseText 1s infinite" : "none"
                                }}>
                                    {cell.isChan ? "C" : "L"}
                                </div>
                            )}
                            {cell && cell.isNewest && (
                                <div style={{ position: "absolute", bottom: "1px", right: "1px", width: "4px", height: "4px", background: "#ffc107", borderRadius: "50%" }}></div>
                            )}
                        </div>
                    ))}
                </div>

            </div>

            <style>{`
                @keyframes pulseBong {
                    0% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7); }
                    70% { box-shadow: 0 0 0 3px rgba(255, 193, 7, 0); }
                    100% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0); }
                }
                @keyframes pulseText {
                    0% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.3; transform: scale(1.3); }
                    100% { opacity: 1; transform: scale(1); }
                }
            `}</style>
        </div>
    );
};

export default BangCauXD;